module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/purdue-6580176f6204aa1074bc53952f024c2a.svg";